import { i18n } from "@/i18n";
import { analyticsTagsConstantes } from "@/constantes/analyticsTags";

export default {
  path: "/studea-manager/duplication",
  name: "trainingCourseDuplicateViewLayout",
  component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutWithErrorView.vue"),
  meta: {
    authRequired: true,
    title: i18n.global.t("studea_manager.duplication"),
    breadcrumb: true,
  },
  children: [
    {
      path: "edit",
      name: "trainingCourseDuplicateView",
      component: () => import(/* webpackChunkName: "training-course" */ "@/views/TrainingCourse/DuplicateView.vue"),
      meta: {
        authRequired: true,
        title: i18n.global.t("studea_manager.duplication"),
        breadcrumb: true,
        trackPageView: true,
        trackPageViewTagId: analyticsTagsConstantes.PILOT_DASHBOARD_DATA_DUPLICATION,
      },
    },
    {
      path: "historic",
      name: "historicDuplicateView",
      component: () =>
        import(/* webpackChunkName: "training-course" */ "@/views/TrainingCourse/HistoricDuplicateView.vue"),
      meta: {
        authRequired: true,
        title: i18n.global.t("studea_manager.duplication_historic"),
        breadcrumb: true,
      },
    },
  ],
};
